import { CheckCircle } from '@mui/icons-material';
import { Checkbox } from '@mui/material';
import { ChangeEvent } from 'react';
import { CheckboxCellRendererProps } from 'types/ScenarioManagement.types';

/**
 * MUI Checkbox Cell Renderer
 * @param props
 * @constructor
 */
const CheckboxCellRenderer = (props: CheckboxCellRendererProps) => {
  const { readonly, onChange, data, value, colDef } = props;

  /**
   * Handle change event
   * @param e
   */
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(data?.metadata?.internalId, colDef!.field!, e.target.checked);
    }
  };

  if (readonly) {
    return value && <CheckCircle />;
  }

  return <Checkbox checked={!!value} onChange={handleChange} />;
};

export default CheckboxCellRenderer;
